module.exports = __webpack_public_path__ + "img/newThree.70149074.png";